import { Component, OnDestroy, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

import { Subscription } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    subscriptionAppNewVersion: Subscription;

    constructor(private swUpdate: SwUpdate) { }

    ngOnInit() {
        this.subscriptionAppNewVersion = this.swUpdate.available.subscribe(async res => {
            setTimeout(() => {
                this.swUpdate.activateUpdate().then(() => window.location.reload());
            }, 2000);
        });
    }

    ngOnDestroy() {
        if (this.subscriptionAppNewVersion) {
            this.subscriptionAppNewVersion.unsubscribe();
        }
    }
}
